import Vue from 'vue'
import App from './App.vue'
// import JsonExcel from 'vue-json-excel'
// Vue.component('downloadExcel', JsonExcel)
Vue.config.productionTip = false
import router from './router'
import ElementUI from 'element-ui'
Vue.use(ElementUI)
console.log('process',process.env)
import 'element-ui/lib/theme-chalk/index.css'
new Vue({
    router,
  render: h => h(App),
}).$mount('#app')
